import React, { useState, useEffect, useRef } from 'react';
import { SurveyCreator, SurveyCreatorComponent } from 'survey-creator-react';
import 'survey-core/survey-core.css';
import 'survey-creator-core/survey-creator-core.css';

const defaultCreatorOptions = {
  autoSaveEnabled: false,
  collapseOnDrag: true,
  showLogicTab: true,
  showTranslationTab: false,
};

const defaultEmptyJson = {
  title: 'Survey',
  description: '',
  pages: [
    {
      name: 'page1',
      title: 'Page 1',
      elements: [],
    },
  ],
};

/**
 * SurveyCreatorWidget wraps SurveyJS Creator for drag-and-drop survey building.
 * - initialSurveyJsJson: SurveyJS schema (from ourSurveyToSurveyJS) when editing
 * - onCreatorReady(creator): called with the creator instance so parent can read creator.JSON on Save
 */
export default function SurveyCreatorWidget({ initialSurveyJsJson, onCreatorReady }) {
  const [creator, setCreator] = useState(null);
  const initialJsonRef = useRef(initialSurveyJsJson);

  useEffect(() => {
    if (creator) return;
    const instance = new SurveyCreator(defaultCreatorOptions);
    setCreator(instance);
  }, [creator]);

  useEffect(() => {
    if (!creator) return;
    const json = initialSurveyJsJson && Object.keys(initialSurveyJsJson).length
      ? initialSurveyJsJson
      : defaultEmptyJson;
    // Set survey via JSON object so preview receives it; then refresh so preview panel updates
    if (typeof creator.JSON !== 'undefined') {
      creator.JSON = json;
    } else {
      creator.text = JSON.stringify(json);
    }
    if (typeof creator.refreshDesigner === 'function') {
      creator.refreshDesigner();
    }
    initialJsonRef.current = initialSurveyJsJson;
  }, [creator, initialSurveyJsJson]);

  useEffect(() => {
    if (creator && onCreatorReady) {
      onCreatorReady(creator);
    }
  }, [creator, onCreatorReady]);

  if (!creator) {
    return null;
  }

  return (
    <div style={{ height: '70vh', minHeight: 400, width: '100%' }}>
      <SurveyCreatorComponent creator={creator} />
    </div>
  );
}
